import Phaser from 'phaser';

export class LaunchScene extends Phaser.Scene {
  constructor() {
    super('LaunchScene');
  }

  create(): void {
    const W = this.scale.width;
    const H = this.scale.height;

    // Black backdrop
    this.add.rectangle(0, 0, W, H, 0x000000).setOrigin(0, 0);

    // Soft warm vignette glow that pulses behind the text
    const glow = this.add.graphics();
    glow.fillStyle(0xffe7a8, 0.0);
    glow.fillCircle(W / 2, H / 2, 360);
    glow.alpha = 0;
    this.tweens.add({
      targets: glow,
      alpha: 0.18,
      duration: 1800,
      yoyo: true,
      ease: 'Sine.easeInOut',
    });

    // Decorative star field — slow drift for cinematic feel
    const stars: Phaser.GameObjects.Arc[] = [];
    for (let i = 0; i < 60; i++) {
      const s = this.add.circle(
        Phaser.Math.Between(0, W),
        Phaser.Math.Between(0, H),
        Phaser.Math.FloatBetween(0.6, 1.6),
        0xffffff,
        Phaser.Math.FloatBetween(0.3, 0.9),
      );
      stars.push(s);
      this.tweens.add({
        targets: s,
        alpha: 0.1,
        duration: Phaser.Math.Between(900, 1800),
        yoyo: true,
        repeat: -1,
        delay: Phaser.Math.Between(0, 1200),
      });
    }

    // Main credit text
    const credit = this.add
      .text(W / 2, H / 2, 'a game by\nJessica', {
        fontFamily: 'serif',
        fontSize: '52px',
        color: '#ffe7a8',
        align: 'center',
      })
      .setOrigin(0.5)
      .setAlpha(0);

    // Skip hint, fades in late
    const skip = this.add
      .text(W / 2, H - 50, 'press any key to skip', {
        fontFamily: 'sans-serif',
        fontSize: '14px',
        color: '#888888',
      })
      .setOrigin(0.5)
      .setAlpha(0);

    // Cinematic timeline: fade in → hold → fade out → start TitleScene
    this.tweens.add({
      targets: credit,
      alpha: 1,
      duration: 1400,
      ease: 'Sine.easeIn',
    });
    this.tweens.add({
      targets: credit,
      scale: 1.06,
      duration: 4000,
      ease: 'Sine.easeInOut',
    });
    this.tweens.add({
      targets: skip,
      alpha: 1,
      delay: 1800,
      duration: 600,
    });

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.cameras.main.fadeOut(700, 0, 0, 0);
      this.cameras.main.once('camerafadeoutcomplete', () => {
        this.scene.start('StartScene');
      });
    };

    this.time.delayedCall(3800, finish);

    // Allow skip on any key or pointer
    this.input.keyboard?.once('keydown', finish);
    this.input.once('pointerdown', finish);
  }
}
